// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feature-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 52px 0px 0px;
  gap: 30px;

  width: 340px;
  /* height: 353px; */

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.feature-title {
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 35px;
  line-height: 42px;
  display: flex;
  align-items: center;
  text-align: center;

  color: #6b3cb9;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}

.feature-svg {
  /* Icon */

  width: 64px;
  height: 54.72px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;

  background-color: #ffffff;
}

.feature-copy {
  width: 299px;
  height: 116px;

  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 24px;
  line-height: 29px;
  display: flex;
  align-items: center;
  text-align: center;

  color: #6b3cb9;

  /* Inside auto layout */

  flex: none;
  order: 2;
  flex-grow: 0;
}

@media (max-width: 414px) {
  .feature-title {
    font-size: 30px;
  }

  .feature-copy {
    font-size: 20px;
  }
  .feature-tile-container {
    flex-direction: column;
    gap: 45px;
  }
  
  .feature-container{
    padding: 0;
    /* height: 305px; */
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/FeatureTile.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;;EAET,YAAY;EACZ,mBAAmB;;EAEnB,uBAAuB;;EAEvB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;EAElB,cAAc;;EAEd,uBAAuB;;EAEvB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;;EAET,WAAW;EACX,eAAe;;EAEf,uBAAuB;;EAEvB,UAAU;EACV,QAAQ;EACR,YAAY;;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;;EAEb,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;;EAElB,cAAc;;EAEd,uBAAuB;;EAEvB,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":[".feature-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 52px 0px 0px;\n  gap: 30px;\n\n  width: 340px;\n  /* height: 353px; */\n\n  /* Inside auto layout */\n\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.feature-title {\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 35px;\n  line-height: 42px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n\n  color: #6b3cb9;\n\n  /* Inside auto layout */\n\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n}\n\n.feature-svg {\n  /* Icon */\n\n  width: 64px;\n  height: 54.72px;\n\n  /* Inside auto layout */\n\n  flex: none;\n  order: 1;\n  flex-grow: 0;\n\n  background-color: #ffffff;\n}\n\n.feature-copy {\n  width: 299px;\n  height: 116px;\n\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 29px;\n  display: flex;\n  align-items: center;\n  text-align: center;\n\n  color: #6b3cb9;\n\n  /* Inside auto layout */\n\n  flex: none;\n  order: 2;\n  flex-grow: 0;\n}\n\n@media (max-width: 414px) {\n  .feature-title {\n    font-size: 30px;\n  }\n\n  .feature-copy {\n    font-size: 20px;\n  }\n  .feature-tile-container {\n    flex-direction: column;\n    gap: 45px;\n  }\n  \n  .feature-container{\n    padding: 0;\n    /* height: 305px; */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
